import React, { useState } from 'react'
import './BewerbungPraktika.scss'
import { useLocation } from 'react-router-dom'
import logo from "../../ressources/arb_black.svg"
// Hilfsfunktionen 
// Funktion: konvertiert "(m_w_d)" zu "(m/w/d)" für die Anzeige
function formatDisplayText(text) {
  if (!text) return "";
  return text.replace(/\(m_w_d\)/gi, "(m/w/d)");
}
// Funktion: Sanitizer für Dateinamen / Felder
function sanitize(input){
  // falls null/undefined -> leeren String verwenden
  const s = String(input ?? "");
  // Ersetze problematische Zeichen (Windows + Pfadtrenner + Quotes) durch Unterstrich
  // Zeichen: / \ : * ? " < > | sowie Steuerzeichen 0-31
  return s.replace(/[\u0000-\u001F\/\\:*?"<>|]+/g, "_").trim();
}
// Auslesen der Dateien
// Funktion: Datei -> Base64
const readFileAsBase64 = file => new Promise((resolve, reject)=>{
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(",").pop());
  r.onerror = reject;
  r.readAsDataURL(file);
});
// Funktion Datei zu Objekt
async function fileToObj(inputEl){
  const f = inputEl.files && inputEl.files[0];
  if(!f) return null;
  return {
    fileName: sanitize(f.name),                    // <<== hier sanitizen
    contentType: f.type || "application/octet-stream",
    fileContent: await readFileAsBase64(f)
  };
}

function BewerbungPraktika() {
// Auslesen der Quere Parameter
const useQuery=() => {
  const {search} = useLocation() 
  return React.useMemo(()=> new URLSearchParams(search), [search])
}

const queryParams = useQuery()

  //  posting-nr sicher lesen + in Zahl umwandeln
  const postingNr = Number.parseInt(
    queryParams.get("posting-nr"),
    10
  );

  const [isInitiative, setIsInitiative] = useState(postingNr === 16);
  const [initiativeText, setInitiativeText] = useState("");

    //Neuer state für Verhinderung von mehrfach Absendung
    const [isSubmitting, setIsSubmitting] = useState(false);

  const jobList = [
    "Studium Elektrotechnik & Informationstechnik",
    "Studium Informatik",
    "Studium Maschinenbau",
    "Studium Mechatronik",
    "Elektroniker (m_w_d) für Automatisierungstechnik",
    "Fachinformatiker (m_w_d)",
    "Fachkraft (m_w_d) für Lagerlogistik",
    "Industriekaufmann (m_w_d)",
    "Industriemechaniker (m_w_d)",
    "Konstruktionsmechaniker (m_w_d) – Feinblechbautechnik",
    "Kunststoff- und Kautschuktechnologie (m_w_d)",
    "Mechatroniker (m_w_d)",
    "Metallfeinbearbeiter (m_w_d)",
    "Technischer Produktdesigner (m_w_d)",
    "Zerspanungsmechaniker (m_w_d)",
    "Initiativbewerbung Schulpraktika",
    "Orientierungspraktikum - Berufswelten entdecken (m_w_d)",
    "Fachpraktikum - Metall und Technik",
    "Fachpraktikum - Elektronik und IT"
  ];

  const selectedJob =
  Number.isInteger(postingNr) &&
  postingNr >= 1 &&
  postingNr <= jobList.length
    ? jobList[postingNr - 1]
    : null;

    console.log("DEBUG", {
      raw: queryParams.get("posting-nr"),
      postingNr,
      selectedJob,
      length: jobList.length
    });
    



console.log(queryParams.get('posting-nr'));
//let postingNr = queryParams.get('posting-nr');


const FLOW_URL = "https://default77be9650940e40d58bb75b97f5e086.41.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/dfd31053fe14441c82673b02206d822f/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=74QKMt_mkTfHyP7eTWcrPlTpFJLH5HpImvOWgvcQ1Gc";
const CLASS_LEVELS = ["5","6","7","8","9","10","11","12","13", "Sonstiges"];
const SCHOOL_TYPES = ["Sonstiges", "Werkrealschule", "Realschule","Gemeinschaftsschule","Gymnasium","Berufsschule/BK"];
const SCHOOL_INDEX = {
  "Stuttgart": {"Gymnasium": ["Karls-Gymnasium"]},
  "Tübingen": {"Realschule": ["Walter-Erbe-Realschule Tübingen"]},
  "Horb a.N.": {"Gymnasium": ["Martin-Gerbert-Gymnasium Horb"],"Realschule": ["Realschule Horb"],"Sonstiges": ["Roßbergschule Horb"]},
  "Horb-Altheim": {"Werkrealschule": ["Grund- und Werkrealschule Horb-Altheim"]},
  "Sulz a.N.": {"Gymnasium": ["Albeck-Gymnasium Sulz"],"Realschule": ["Lina-Hähnle-Realschule"]},
  "Alpirsbach": {"Realschule": ["Realschule Oberes Kinzigtal"],"Werkrealschule": ["Werkrealschule Oberes Kinzigtal"]},
  "Dornhan": {"Realschule": ["John-Bühler-Realschule Dornhan"]},
  "Nagold": {"Gymnasium": ["Technisches Gymnasium Nagold"],"Realschule": ["Christiane-Herzog-Realschule Nagold"],"Sonstiges": ["Rolf-Benz-Schule Nagold"]},
  "Altensteig": {"Gymnasium": ["Christophorus-Gymnasium Altensteig"],"Realschule": ["Friedrich-Boysen-Realschule Altensteig"]},
  "Freudenstadt": {"Gymnasium": ["Kepler-Gymnasium", "Heinrich-Schickhardt-Schule"],"Werkrealschule": ["Kepler-Werkrealschule", "Werkrealschule Freudenstadt"],"Realschule": ["Falkenrealschule Freudenstadt"],"Berufsschule/BK": ["Kaufmännisches Berufskolleg Freudenstadt"],"Sonstiges": ["Heinrich-Schickhardt-Schule","Eduard-Spranger-Schule Freudenstadt","Christophorus-Schule Freudenstadt","Luise-Büchner-Schule","Freie Waldorfschule Freudenstadt"]},
  "Baiersbronn": {"Gymnasium": ["Richard-von-Weizsäcker-Gymnasium"],"Realschule": ["Johannes-Gaiser-Realschule Baiersbronn"],"Werkrealschule": ["Johannes-Gaiser-Werkrealschule Baiersbronn"]},
  "Dornstetten": {"Gymnasium": ["Gymnasium Dornstetten"],"Realschule": ["Realschule Dornstetten"]},
  "Pfalzgrafenweiler": {"Realschule": ["Realschule Pfalzgrafenweiler"]},
  "Loßburg": {"Realschule": ["Realschule Loßburg"],"Gemeinschaftsschule": ["Gemeinschaftsschule Loßburg"]},
  "Schopfloch": {"Sonstiges": ["GMS Schopfloch-Waldachtal"]},
  "Oberwolfach": {"Sonstiges": ["Wolfitalschule Oberwolfach"]},
  "Wolfach": {"Realschule": ["Realschule Wolfach"]},
  "Sonstiges": {},
  "Hausach": {"Gymnasium": ["Robert-Gerwig-Gymnasium Hausach"]},
  "Ettenheim": {"Gymnasium": ["Gymnasium Ettenheim"]},
  "Rottweil": {"Gymnasium": ["Technisches Gymnasium Rottweil"]},
  "Schramberg": {"Gymnasium": ["Gymnasium Schramberg"]},
  "Oberndorf a.N.":{"Gymnasium":["Gymnasium am Rosenberg"],"Realschule":["Realschule Oberndorf"],"Werkrealschule":["Werkrealschule Oberndorf"]},
  "Ehingen": {"Berufsschule/BK": ["Kaufmännische Schule Ehingen"]},
  
};

const SCHOOL_ADDRESS = {
  // Stuttgart
  "Karls-Gymnasium": { street: "Tübinger Straße 38", city: "70178 Stuttgart" },
 
  // Tübingen
  "Walter-Erbe-Realschule Tübingen": { street: "Primus-Truber-Straße 33", city: "72072 Tübingen" },
 
  // Horb am Neckar
  "Realschule Horb": { street: "Lerchenstraße 115", city: "72160 Horb am Neckar" },
  "Roßbergschule Horb": { street: "Roßbergstraße 11", city: "72160 Horb am Neckar" },
  "Martin-Gerbert-Gymnasium Horb": { street: "Fürstabt-Gerbert-Straße 21", city: "72160 Horb am Neckar" },
 
  // Horb-Altheim
  "Grund- und Werkrealschule Horb-Altheim": { street: "Hindenburgstraße 53", city: "72160 Horb-Altheim" },
 
  // Sulz am Neckar
  "Albeck-Gymnasium Sulz": { street: "Weilerstraße 79", city: "72172 Sulz am Neckar" },
  "Lina-Hähnle-Realschule": { street: "Karl-Schöpfer-Weg 2", city: "72172 Sulz am Neckar" },
 
  // Alpirsbach
  "Realschule Oberes Kinzigtal": { street: "Sulzberg 52", city: "72275 Alpirsbach" },
  "Werkrealschule Oberes Kinzigtal": { street: "Sulzberg 52", city: "72275 Alpirsbach" },
 
  // Dornhan
  "John-Bühler-Realschule Dornhan": { street: "Schulstraße 21", city: "72175 Dornhan" },
 
  // Nagold
  "Rolf-Benz-Schule Nagold": { street: "Max-Eyth-Straße 23", city: "72202 Nagold" },
  "Christiane-Herzog-Realschule Nagold": { street: "Hölderlinstraße 16", city: "72202 Nagold" },
  "Technisches Gymnasium Nagold": { street: "Max-Eyth-Straße 23", city: "72202 Nagold" },
 
  // Altensteig
  "Friedrich-Boysen-Realschule Altensteig": { street: "Speidelstraße 19", city: "72213 Altensteig" },
  "Christophorus-Gymnasium Altensteig": { street: "Gymnasiumstraße 18", city: "72213 Altensteig" },
 
  // Freudenstadt
  "Kepler-Gymnasium": { street: "Ludwig-Jahn-Straße 54", city: "72250 Freudenstadt" },
  "Kepler-Werkrealschule": { street: "Ludwig-Jahn-Straße 54", city: "72250 Freudenstadt" },
  "Heinrich-Schickhardt-Schule": { street: "Eugen-Nägele-Straße 40", city: "72250 Freudenstadt" },
  "Werkrealschule Freudenstadt": { street: "Ludwig-Jahn-Straße 54", city: "72250 Freudenstadt" },
  "Eduard-Spranger-Schule Freudenstadt": { street: "Eugen-Nägele-Straße 40", city: "72250 Freudenstadt" },
  "Christophorus-Schule Freudenstadt": { street: "Ludwig-Jahn-Straße 32", city: "72250 Freudenstadt" },
  "Falkenrealschule Freudenstadt": { street: "Bahnhofstraße 31", city: "72250 Freudenstadt" },
  "Luise-Büchner-Schule": { street: "Eugen-Nägele-Straße 40", city: "72250 Freudenstadt" },
  "Kaufmännisches Berufskolleg Freudenstadt": { street: "Eugen-Nägele-Straße 40", city: "72250 Freudenstadt" },
  "Freie Waldorfschule Freudenstadt": { street: "Friedrich-List-Straße 14", city: "72250 Freudenstadt" },
 
  // Baiersbronn
  "Johannes-Gaiser-Werkrealschule Baiersbronn": { street: "Nogent-le-Rotrou-Straße 8", city: "72270 Baiersbronn" },
  "Johannes-Gaiser-Realschule Baiersbronn": { street: "Nogent-le-Rotrou-Straße 8", city: "72270 Baiersbronn" },
  "Richard-von-Weizsäcker-Gymnasium": { street: "Oberdorfstraße 68", city: "72270 Baiersbronn" },
 
  // Dornstetten
  "Gymnasium Dornstetten": { street: "Riedsteige 9", city: "72280 Dornstetten" },
  "Realschule Dornstetten": { street: "Waldstraße 16", city: "72280 Dornstetten" },
 
  // Pfalzgrafenweiler
  "Realschule Pfalzgrafenweiler": { street: "Burgstraße 31", city: "72285 Pfalzgrafenweiler" },
 
  // Loßburg
  "Realschule Loßburg": { street: "Obere Schulstraße 1", city: "72290 Loßburg" },
  "Gemeinschaftsschule Loßburg": { street: "Obere Schulstraße 1", city: "72290 Loßburg" },
 
  // Schopfloch
  "GMS Schopfloch-Waldachtal": { street: "Schulstraße 14", city: "72296 Schopfloch" },
 
  // Oberwolfach
  "Wolfitalschule Oberwolfach": { street: "Schulstraße 27", city: "77709 Oberwolfach" },
 
  // Wolfach
  "Realschule Wolfach": { street: "Herlinsbachweg 4", city: "77709 Wolfach" },
 
  // Hausach
  "Robert-Gerwig-Gymnasium Hausach": { street: "Hauptstraße 33", city: "77756 Hausach" },
 
  // Ettenheim
  "Gymnasium Ettenheim": { street: "J.-B.-von-Weiß-Straße 7", city: "77955 Ettenheim" },
 
  // Rottweil
  "Technisches Gymnasium Rottweil": { street: "Heerstraße 150", city: "78628 Rottweil" },
 
  // Schramberg
  "Gymnasium Schramberg": { street: "Berneckstraße 32", city: "78713 Schramberg" },
 
  // Oberndorf am Neckar
  "Gymnasium am Rosenberg": { street: "Eugen-Frueth-Straße 5", city: "78727 Oberndorf am Neckar" },
  "Realschule Oberndorf": { street: "Oberamteistraße 8", city: "78727 Oberndorf am Neckar" },
 
  // Ehingen
  "Kaufmännische Schule Ehingen": { street: "Schulgasse 11", city: "89584 Ehingen" },
 
  // Würzburg
  "Siebold-Gymnasium Würzburg": { street: "Rennweger Ring 11", city: "97070 Würzburg" },
};
const [schoolCity, setSchoolCity]=useState("")
const [schoolType, setSchoolType]=useState("")
const [schoolSuggestion, setSchoolSuggestion] = useState("")
const [schoolStreetCustom, setSchoolStreetCustom] = useState("")
const [schoolCityCustom, setSchoolCityCustom] = useState("")

// Klassenangabe
const [classLevel, setClassLevel] = useState("");

// Datumsanagabe
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

// Referrals - Wie bist du auf das Praktikum aufmerksam geworden?
const [referral, setReferral] = useState([]);
const changeReferrals = (e) => {
  const val = e.target.value.replace("/", "_")
  if(e.target.checked === false) {
    setReferral(referral.filter(el => el !== val))
  } else {
    setReferral([...referral, val])
  }
}

// Erfolgsmeldung
const [success, setSuccess] = useState(false);

// Formular absenden
const submitForm = async (event) => {
  setIsSubmitting(true); //26.3.26
  event.preventDefault(); // stoppt das normale Absenden
  const form = event.target; // <form> selbst


  console.log("Form wurde abgesendet");

  // Alle Felder sicher auslesen
  const salutation  = form.salutation?.value ?? "";
  const firstName   = sanitize(form.firstName?.value.trim());
  const lastName    = sanitize(form.lastName?.value.trim());
  const birthDate   = form.birthDate?.value ?? "";
  const phone       = sanitize(form.phone?.value.trim());
  const email       = sanitize(form.email?.value.trim());
  const interestVal = sanitize(form.interest?.value.trim() ?? "");

  const addressStreet      = sanitize(form.addressStreet?.value.trim());
  const addressHouseNumber = sanitize(form.addressHouseNumber?.value.trim());
  const addressPostalCode  = sanitize(form.addressPostalCode?.value.trim());
  const addressCity        = sanitize(form.addressCity?.value.trim());

  const schoolCityVal  = form.schoolCity?.value ?? "";
  const schoolTypeVal  = form.schoolType?.value ?? "";
  const schoolNameVal  = sanitize(form.schoolName?.value ?? "");
  const schoolOtherVal = sanitize(form.schoolOther?.value.trim());
  const hasOther       = schoolOtherVal.length > 0;
  const schoolFinalVal = sanitize(hasOther ? schoolOtherVal : schoolNameVal);

  const classLevelVal       = form.classLevel?.value ?? "";
  const internshipTypeVal   = form.internshipType?.value ?? "";
  const startDateVal        = form.startDate?.value ?? "";
  const endDateVal          = form.endDate?.value ?? "";

  // Für desiredJob: fallback auf selectedJob, wenn disabled
  const desiredJobVal = sanitize(selectedJob ?? form.desiredJob?.value ?? "");

  // Dateien
  const coverLetter = await fileToObj(form.fileCoverLetter);
  const cv          = await fileToObj(form.fileCv);
  const certificate = await fileToObj(form.fileCertificate);
  const other       = await fileToObj(form.fileOther);

  const payload = {
    salutation,
    firstName,
    lastName,
    birthDate,
    phone,
    email,
    interest: interestVal,
    addressStreet,
    addressHouseNumber,
    addressPostalCode,
    addressCity,
    schoolCity: schoolCityVal,
    schoolType: schoolTypeVal,
    schoolName: schoolNameVal,
    schoolOther: schoolOtherVal,
    schoolFinal: schoolFinalVal,
    classLevel: classLevelVal,
    internshipType: internshipTypeVal,
    startDate: startDateVal,
    endDate: endDateVal,
    desiredJob: desiredJobVal,
    schoolStreetHouse: sanitize(form.schoolStreetHouse?.value ?? ""),
    schoolPostalCity: sanitize(form.schoolPostalCity?.value ?? ""),
    attachments: {
      ...(coverLetter ? { coverLetter } : {}),
      ...(cv ? { cv } : {}),
      ...(certificate ? { certificate } : {}),
      ...(other ? { other } : {})
    },
    referral
  };

  try {
    const res = await fetch(FLOW_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    if(!res.ok) throw new Error("HTTP "+res.status);
    const data = await res.json().catch(()=> ({}));
    console.log(data.message || "Erfolgreich übermittelt");
    setSuccess(true);
  } catch(err){
    console.error(err);
    window.alert("Something went Wrong! Please try again later");



  } finally {

    setIsSubmitting(false);  // Button wieder freigeben
  }


  console.log(payload);
}


  return (
    <>
      <div className='react-prakti-formular'>
        <div className="main-container">

        <div className="logo-glass-container">
          <a href = "https://ausbildung.arburg.com" style={{textDecoration: "none"}}>
          <img alt="Logo of Arburg" src={logo} className="logo"/>
         </a>

         <h2 className="subtitle">Praktikum</h2>
  
        </div>

        {selectedJob && (
  <div id="postingInfo">
    <div>Bewerbung auf</div>
    <div id="postingInfoText">
      {formatDisplayText(selectedJob)}
    </div>
  </div>
)}



<form id="form" onSubmit={submitForm} method='post'>
  {/* <!-- Person --> */}
  <fieldset>
    <legend>Person</legend>

    <div className="form-group">
      <label htmlFor="salutation">Anrede *</label>
      <select id="salutation" name="salutation" required>
        <option value="">Bitte wählen</option>
        <option value="Herr">Herr</option>
        <option value="Frau">Frau</option>
        <option value="Divers">Divers</option>
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="firstName">Vorname *</label>
      <input id="firstName" name="firstName" type="text" required/>
    </div>

    <div className="form-group">
      <label htmlFor="lastName">Nachname *</label>
      <input id="lastName" name="lastName" type="text" required/>
    </div>

    <div className="form-group">
      <label htmlFor="birthDate">Geburtsdatum *</label>
      <input id="birthDate" name="birthDate" type="date" required/>
    </div>

    <div className="form-group">
      <label htmlFor="phone">Telefon *</label>
      <input id="phone" name="phone" type="tel" pattern="^\+?[0-9][0-9\s\-\/()]{6,}$" placeholder="+49 151 23456789" required/>
    </div>

    <div className="form-group">
      <label htmlFor="email">E‑Mail *</label>
      <input id="email" name="email" type="email" required/>
    </div>
  </fieldset>

  {/* <!-- Adresse --> */}
  <fieldset>
    <legend>Adresse</legend>

    <div className="form-group">
      <label htmlFor="addressStreet">Straße *</label>
      <input id="addressStreet" name="addressStreet" type="text" required/>
    </div>

    <div className="form-group">
      <label htmlFor="addressHouseNumber">Haus‑Nr. *</label>
      <input id="addressHouseNumber" name="addressHouseNumber" type="text" required/>
    </div>

    <div className="form-group">
      <label htmlFor="addressPostalCode">PLZ *</label>
      <input id="addressPostalCode" name="addressPostalCode" type="text" inputMode="numeric" pattern="^\d{5}$" placeholder="72290" required/>
    </div>

    <div className="form-group">
      <label htmlFor="addressCity">Ort *</label>
      <input id="addressCity" name="addressCity" type="text" required/>
    </div>
  </fieldset>

  {/* <!-- Schule --> */}
  <fieldset>
    <legend>Schule</legend>

    <div className="form-group">
      
      <label htmlFor="schoolCity">Schulort *</label>
      <select
  id="schoolCity"
  name="schoolCity"
  required
  onChange={(e) => setSchoolCity(e.target.value)}
>
  {Object.keys(SCHOOL_INDEX)
  //Neu heute 27/02/2026
.sort((a, b) => {
  if (a === "Sonstiges") return -1;
  if (b === "Sonstiges") return 1;
  return a.localeCompare(b, "de");
})
    .map((index) => (
      <option key={index} value={index}>
        {index}
      </option>
    ))}
</select>


    </div>

    <div className="form-group">
      <label htmlFor="schoolType">Schulart *</label>
      <select id="schoolType" name="schoolType" required onChange={(e) => setSchoolType (e.target.value)}>
        {SCHOOL_TYPES.map((index)=> {
          return <option value={index} key={index}>{index}</option>
        })}
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="schoolName">Schule (Vorschlag)</label>
  <select
    id="schoolName"
    name="schoolName"
    disabled={schoolType === "" || schoolCity === ""}
    onChange={(e) => {
      setSchoolSuggestion(e.target.value);
      if (e.target.value !== "") {
        // Wenn ein Vorschlag ausgewählt wird, lösche ggf. Sonstiges
        const otherInput = document.getElementById("schoolOther");
        if (otherInput) otherInput.value = "";
      }
    }}
  >
    {schoolType === "" || schoolCity === "" ? (
      <option value="">Bitte Schulort & -art wählen</option>
    ) : (
      <>
        <option value={""}>Kein Vorschlag ausgewählt</option>
        {SCHOOL_INDEX[schoolCity][schoolType] !== undefined
          ? SCHOOL_INDEX[schoolCity][schoolType].map((index) => (
              <option key={index} value={index}>
                {index}
              </option>
            ))
          : null}
      </>
    )}
  </select>
    </div>

    <div className="form-group">
      <label htmlFor="schoolOther">Sonstiges</label>
      <input id="schoolOther" name="schoolOther" type="text" placeholder="Schulname (frei)" disabled={schoolSuggestion === "" ? false : true}/>
    </div>


    <div className="form-group">
      <label htmlFor="schoolPostalCity">PLZ + Ort der Schule</label>
      <input 
        id="schoolPostalCity" 
        name="schoolPostalCity" 
        type="text" 
        disabled={schoolSuggestion === "" ? false : true} 
        placeholder="Automatisch ausgefüllt" 
        onChange={(e) => setSchoolCityCustom(e.target.value)}
        value={
          schoolSuggestion === "" ? schoolCityCustom : SCHOOL_ADDRESS[schoolSuggestion].city
        }/>
    </div>
    
    <div className="form-group">
      <label htmlFor="schoolStreetHouse">Straße + Hausnummer der Schule</label>
      <input 
        id="schoolStreetHouse" 
        name="schoolStreetHouse" 
        type="text" 
        disabled={schoolSuggestion === "" ? false : true} 
        placeholder="Automatisch ausgefüllt"
        onChange={(e) => setSchoolStreetCustom(e.target.value)}
        value={
          schoolSuggestion === "" ? schoolStreetCustom : SCHOOL_ADDRESS[schoolSuggestion].street
        }/>
    </div>
    



  </fieldset>

  {/* <!-- Klasse / Praktikum --> */}
  <fieldset>
    <legend>Klasse & Praktikum</legend>

    <div>
      <span>Klasse (Jahrgang) *</span><br id="classBreak"/>
      <div id="classLevelGroup">
        {CLASS_LEVELS.map((index) => {
        return (
          <label key={index}>
            <input type='radio' onChange={() => setClassLevel(index)} value={index} name="classLevelRadio" id={`cl_${index}`} />
            {index}
          </label>
        )
      })}
      </div>
      <input type="hidden" id="classLevel" name="classLevel" required value={classLevel}/>
    </div>
     <br/>

    <div className = "internship-container">
      <span>Art des Praktikums *</span> <br/>
      <label><input type="radio" name="internshipType" value="Schulisch" required/> Schulisch</label> <br/>
      <label><input type="radio" name="internshipType" value="Freiwillig" required/> Freiwillig</label> <br/>
      <label><input type="radio" name="internshipType" value="Sonstiges" required/> Sonstiges</label> <br/>
    </div>
     <br/>

    <label htmlFor="startDate">Startdatum *</label>
    <input id="startDate" name="startDate" type="date" max={endDate} onChange={(e) => setStartDate(e.target.value)} required/>
     <br/>

    <label htmlFor="endDate">Enddatum *</label>
    <input id="endDate" name="endDate" type="date" min={startDate} onChange={(e) => setEndDate(e.target.value)} required/>
     <br/>

    <label htmlFor="desiredJob">Berufswunsch *</label>
    {/* <select defaultValue={postingNr=== null || postingNr >= jobList.length?"" : jobList[postingNr]} id="desiredJob" name="desiredJob" required disabled = {postingNr=== null || postingNr >= jobList.length?false : true}> */}
    <select
  id="desiredJob"
  name="desiredJob"
  required
  defaultValue={selectedJob ?? ""}
  disabled={!!selectedJob}
  onChange={(e) => {
    const value = e.target.value;
    setIsInitiative(value === "Initiativbewerbung Schulpraktika");
  }}
>

      <option value="" disabled>Bitte wählen</option>
      <option value="Studium Elektrotechnik & Informationstechnik">Studium Elektrotechnik & Informationstechnik</option>
      <option value="Studium Informatik">Studium Informatik</option>
      <option value="Studium Maschinenbau">Studium Maschinenbau</option>
      <option value="Studium Mechatronik">Studium Mechatronik</option>
      <option value="Elektroniker (m_w_d) für Automatisierungstechnik">Elektroniker (m/w/d) für Automatisierungstechnik</option>
      <option value="Fachinformatiker (m_w_d)">Fachinformatiker (m/w/d)</option>
      <option value="Fachkraft (m_w_d) für Lagerlogistik">Fachkraft (m/w/d) für Lagerlogistik</option>
      <option value="Industriekaufmann (m_w_d)">Industriekaufmann (m/w/d)</option>
      <option value="Industriemechaniker (m_w_d)">Industriemechaniker (m/w/d)</option>
      <option value="Konstruktionsmechaniker (m_w_d) – Feinblechbautechnik">Konstruktionsmechaniker (m/w/d) – Feinblechbautechnik</option>
      <option value="Kunststoff- und Kautschuktechnologie (m_w_d)">Kunststoff- und Kautschuktechnologie (m/w/d)</option>
      <option value="Mechatroniker (m_w_d)">Mechatroniker (m/w/d)</option>
      <option value="Metallfeinbearbeiter (m_w_d)">Metallfeinbearbeiter (m/w/d)</option>
      <option value="Technischer Produktdesigner (m_w_d)">Technischer Produktdesigner (m/w/d)</option>
      <option value="Zerspanungsmechaniker (m_w_d)">Zerspanungsmechaniker (m/w/d)</option>
      <option value="Initiativbewerbung Schulpraktika">Initiativbewerbung Schulpraktika</option>
      <option value="Orientierungspraktikum - Berufswelten entdecken (m_w_d)">Orientierungspraktikum - Berufswelten entdecken (m/w/d)</option>
      <option value="Fachpraktikum - Metall und Technik">Fachpraktikum - Metall & Technik</option>
      <option value="Fachpraktikum - Elektronik und IT">Fachpraktikum - Elektronik & IT</option>
    </select>

    {isInitiative && (
  <>
    <label htmlFor="initiativeTopics">
      Welche Themen interessieren dich für das Praktikum? *
    </label>

    <textarea
      id="initiativeTopics"
      name="interest"
      rows="3"
      maxLength={255}
      value={initiativeText}
      required={isInitiative}
      onChange={(e) => setInitiativeText(e.target.value)}
      style={{
        backgroundColor: "#ffffff",     // hell
        border: "1px solid #ccc",       // gleiche Linie wie andere Felder
        padding: "8px",
        borderRadius: "4px",
        width: "100%",
        resize: "vertical",
        outline: "none",
      }}
      onFocus={(e) => {
        e.target.style.backgroundColor = "#ffffff";  
        e.target.style.border = "1px solid #999";     // leicht dunklerer Rand wie bei Input-Fokus
      }}
      onBlur={(e) => {
        e.target.style.backgroundColor = "#ffffff";  
        e.target.style.border = "1px solid #ccc";
      }}
    />
  </>
)}
    
    
  </fieldset>

  
  <fieldset>
    <legend>Datei‑Uploads</legend>

    <label htmlFor="fileCoverLetter">Anschreiben (optional)</label>
    <input id="fileCoverLetter" type="file" accept=".pdf,.doc,.docx"/>
     <br/>

    <label htmlFor="fileCv">Lebenslauf (optional)</label>
    <input id="fileCv" type="file" accept=".pdf,.doc,.docx"/>
     <br/>

    <label htmlFor="fileCertificate">Zeugnis *</label>
    <input id="fileCertificate" type="file" accept="application/pdf,image/*" required/>
     <br/>

    <label htmlFor="fileOther">Sonstiges (optional)</label>
    <input id="fileOther" type="file"/>
  </fieldset>

<fieldset id="referralFieldset">
<legend>Wie bist Du auf das Praktikum aufmerksam geworden? (optional)</legend>

<div id="referralGroup">
  <label><input type="checkbox" name="referral[]" value="TOPJOB" onChange={changeReferrals}/> TOPJOB</label>
  <label><input type="checkbox" name="referral[]" value="Eltern/Verwandte arbeiten im Betrieb" onChange={changeReferrals}/> Eltern/Verwandte arbeiten im Betrieb</label>
  <label><input type="checkbox" name="referral[]" value="Eltern sind Kunden" onChange={changeReferrals}/> Eltern sind Kunden</label>
  <label><input type="checkbox" name="referral[]" value="Infotage" onChange={changeReferrals}/> Infotage</label>
</div>

<label htmlFor="referralOther">Sonstiges:</label>
<textarea id="referralOther" name="referralOther" rows="3" placeholder="z. B. Schulveranstaltung, Freunde, Internet…"></textarea>
</fieldset>

  {/* <!--Datenschutz --> */}

  <fieldset>
    <legend>Einverständniserklärung</legend>
  
    <div style={{display:"flex", alignItems:"center", gap:"8px", position:"relative"}}>
      <input type="checkbox" required id="agreePrivacy" style= {{width:"16px", height:"16px", margin:"0"}}/>
      <label htmlFor="agreePrivacy" style = {{margin:"0", lineHeight:"1.3"}}>
        Ich habe die {" "}
        <a className = "data-privacy_link" href="https://www.arburg.com/de/datenschutz/"  target="_blank" style = {{color:"#33CC99"}}>
          Datenschutzerklärung</a> gelesen und stimme zu. <span style = {{color: "red"}}>*</span>
      </label>
  
      {/* <!-- Hidden Detail Div --> */}
      <div className="privacy-detail" style={{         
          display:"none",
          position:"absolute",
          top:"100%",
          left:"0",
          zIndex:"10",
          background:"#f9f9f9",
          border:"1px solid #ccc", 
          padding:"10px",
          width:"300px",
          boxShadow:"0 2px 6px rgba(0,0,0,0.2)",
          fontSize:"0.9em",
          marginTop:"4px"}}

      >
        <strong>Datenschutzerklärung im Detail:</strong>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
      </div> 
    </div>
  </fieldset>



  <button
  id="submitBtn"
  type="submit"
  disabled={isSubmitting}
>
  {isSubmitting ? "Sende..." : "Absenden"}
</button>

  <p id="msg" role="status" aria-live="polite"></p>
</form>

{/* <!-- Erfolgreich übermittelt Popup --> */}

{success === true &&
  <>
    {/* NEU: Blocker der das komplette Formular deaktiviert */}
    <div className="overlay-blocker"></div>

    {/* Erfolgspopup */}
    <div id="successPopup" className="popup">
      <div className="popup-content">

        {/* Grünes Häkchen */}
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: "0.5rem" }}>
          <circle cx="12" cy="12" r="12" fill="#33cc99" fillOpacity="0.2" />
          <path d="M6 12l4 4 8-8" stroke="#33cc99" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

        <h2>Vielen Dank!</h2>

        <p id="popupMessage">
        &#x1F389;Deine Bewerbung wurde erfolgreich übermittelt! <br/><br/>
          Wir prüfen alles sorgfältig und melden uns so schnell wie möglich bei dir. <br/><br/>
          Du erhältst bis spätestens zum nächsten Werktag eine Eingangsbestätigung per E-Mail.
          Solltest du keine Bestätigung erhalten, melde dich bitte unter ausbildung@arburg.com. <br/><br/>
          Das Fenster kann jetzt geschlossen werden.
        </p>

      </div>
    </div>
  </>
}


{/* <!-- Bestehende Statusmeldung --> */}
<div id="msg" className="status-message"></div>


</div>
       </div>
    </>
  )
}

export default BewerbungPraktika
